import React from 'react'
import CustomCommandBarMenuItem from '../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';

import abilityBuild from '../../shared/CASL/appAbility';
import { checkRoles } from '../../hoc/CheckRoles';
import { RoleContext } from '../../shared/enums';
import { RootState } from '../../store';

import { Selection, CommandBar, DefaultButton, Dialog, DialogFooter, DialogType, IButtonProps, ICommandBarItemProps, ICommandBarStyles, IDialogContentProps, IPivotStyles, Label, mergeStyleSets, Pivot, PivotItem, PrimaryButton } from '@fluentui/react';
import { connect, ConnectedProps } from 'react-redux';
import { IForwardRule, ITitolario } from '../../shared/interfaces';
import { Unsubscribe } from '@casl/ability';
import filingPlanService from '../../services/filingPlan.service';
import AddEditFilingPlanNode from './AddEditFilingPlanNode';
import FilingPlanTree from './FilingPlanTree';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ForwardRulesTable from '../ForwardRules/ForwardRulesTable';
import forwardRulesService from '../../services/forwardRules.service';
import AddEditForwardRule from '../ForwardRules/AddEditForwardRule';
import { toastRef } from '../Layout/Layout';

const classNames = mergeStyleSets({
    overFlowHidden: {
        overflow: 'hidden'
    },
    detailsListRow: {
        '.ms-DetailsRow-check': {
            height: '100%',
            width: 36
        },
        '.ms-DetailsRow-fields .ms-DetailsRow-cell': {
            paddingLeft: 0

        }
    }
});

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};
const pivotBarStyles: Partial<IPivotStyles> = {

    root: { padding: '0 24px' },
    itemContainer: { overflow: 'hidden', height: '100%' }
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};


const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface FilingPlanProps {

}

type Props = FilingPlanProps & RouteComponentProps & PropsFromRedux;

export interface FilingPlanState {
    commandBarItems: ICommandBarItemProps[],
    selectedFilingPlanNode?: ITitolario,
    selectedFilingPlanNodeKey?: string,
    selectedForwardRule?: IForwardRule
    lateralPanelIsOpen: boolean,
    lateralPanelBodyContent: Function,
    lateralPanelSubmitFunction: Function,
    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogSubmitFunction: Function,
    newFilingPlanNode?: ITitolario,
    loadingFilingPlan: boolean,
    loadingForwardRulesList: boolean,
    forceFilingPlanTreeRefresh: boolean,
    forceForwardRulesTableRefresh: boolean
}


class FilingPlan extends React.Component<Props, FilingPlanState> {
    unsubscribeFromAbility: Unsubscribe = () => { };
    private forwardRuleSelection: Selection;


    constructor(props) {
        super(props);

        this.forwardRuleSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.forwardRuleSelection.getSelection()[0] as IForwardRule;
                this.setState({ selectedForwardRule: selection });
            },
        });

        this.state = {
            commandBarItems: [],
            lateralPanelIsOpen: false,
            lateralPanelBodyContent: () => { },
            lateralPanelSubmitFunction: () => { },
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
            loadingFilingPlan: false,
            loadingForwardRulesList: false,
            forceFilingPlanTreeRefresh: false,
            forceForwardRulesTableRefresh: false
        }

    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            this.updateCommandBarItems();
        });

        if (this.props.currentAoo) {
            this.updateCommandBarItems();
        }
    }

    componentDidUpdate(oldProps: Props, oldState: FilingPlanState) {
        if (oldProps.currentAoo !== this.props.currentAoo ||
            oldState.selectedFilingPlanNode !== this.state.selectedFilingPlanNode ||
            oldState.selectedForwardRule !== this.state.selectedForwardRule) {
            this.updateCommandBarItems();
        }
        if (oldState.selectedFilingPlanNode !== this.state.selectedFilingPlanNode) {

            this.updateCommandBarItems();
        }
        if (oldState.selectedFilingPlanNode != this.state.selectedFilingPlanNode) {
            this.updateCommandBarItems();
        }

    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
    }


    updateCommandBarItems = () => {
        let { selectedFilingPlanNode } = this.state;
        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (abilityBuild.can('create', 'ITitolario'))
            newCommandBarItems.push(
                {
                    key: 'addFilingPlanNode',
                    iconProps: { iconName: 'Add' },
                    text: 'Aggiungi voce',
                    onClick: this.addFilingPlanNodeHandler
                });

        if (abilityBuild.can('update', 'ITitolario') && selectedFilingPlanNode)
            newCommandBarItems.push({
                key: 'editFilingPlanNode',
                iconProps: { iconName: 'Edit' },
                text: 'Modifica voce',
                onClick: this.editFilingPlanNodeHandler
            });

        if (abilityBuild.can('delete', 'ITitolario') && selectedFilingPlanNode)
            newCommandBarItems.push({
                key: 'deleteFilingPlanNode',
                iconProps: { iconName: 'Delete' },
                text: 'Elimina voce',
                onClick: this.deleteFilingPlanNodeHandler
            });

        if (abilityBuild.can('create', 'IForwardRule') && this.state.selectedFilingPlanNode)
            newCommandBarItems.push(
                {
                    key: 'addForwardRuleHandler',
                    iconProps: { iconName: 'Add' },
                    text: 'Aggiungi regola',
                    onClick: this.addForwardRuleHandler
                });

        if (abilityBuild.can('update', 'IForwardRule') && this.state.selectedForwardRule)
            newCommandBarItems.push(
                {
                    key: 'updateForwardRuleHandler',
                    iconProps: { iconName: 'Edit' },
                    text: 'Modifica regola',
                    onClick: this.updateForwardRuleHandler
                });


        if (abilityBuild.can('delete', 'IForwardRule') && this.state.selectedForwardRule)
            newCommandBarItems.push({
                key: 'deleteForwardRuleHandler',
                iconProps: { iconName: 'Delete' },
                text: 'Rimuovi regola',
                onClick: this.deleteForwardRuleHandler
            });



        this.setState({ commandBarItems: newCommandBarItems });

    }

    // Click sul button della commandbar
    addFilingPlanNodeHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditFilingPlanNode
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Nuova voce di titolario'
                    loading={false}
                    selectedFilingPlanNode={this.state.selectedFilingPlanNode}
                    onSubmit={this.addFilingPlanNodeLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={false}
                />

            }
        );
    }

    // Click su salva del panel laterale
    addFilingPlanNodeLateralPanelSubmit = (filingPlanItem: Partial<ITitolario>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi creare una nuova voce di titolario?',
                
            },
            confirmDialogSubmitFunction: () => { this.addFilingPlanNodeConfirmDialogSubmit(filingPlanItem) }

        })

    }

    // Click su conferma del confirm dialog
    addFilingPlanNodeConfirmDialogSubmit = (filingPlanNode: Partial<ITitolario>) => {
        if (this.props.currentAoo) {
            this.setState({ loadingFilingPlan: true });
            let { forceFilingPlanTreeRefresh } = this.state

            filingPlanService.addFilingPlanNode(this.props.currentAoo.id, filingPlanNode)
                .then(result => {
                    this.setState({ forceFilingPlanTreeRefresh: !forceFilingPlanTreeRefresh });
                    toastRef.current?.show({ severity: 'info', summary: filingPlanNode.title, detail: `Voce creata correttamente`, life: 5000 });

                })
                .catch(error => {
                    this.setState({ loadingFilingPlan: false });

                });

            this.setState({ confirmDialogIsOpen: false })

        }
    }

    // Click sul button della commandbar
    addForwardRuleHandler = () => {

        this.setState(
            {
                selectedForwardRule: undefined,
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditForwardRule
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Nuova regola di inoltro'
                    loading={false}
                    targetFieldIsReadOnly={true}
                    selectedForwardRule={{ fieldInternalName: 'Titolario', fieldInternalValue: this.state.selectedFilingPlanNodeKey }}
                    onSubmit={this.addForwardRuleLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                />

            }
        );
        this.forwardRuleSelection.setAllSelected(false);

    }

    // Click su salva del panel laterale
    addForwardRuleLateralPanelSubmit = (forwardRules: Partial<IForwardRule>[]) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi creare una nuova regola di inoltro?',
            },
            confirmDialogSubmitFunction: () => { this.addForwardRuleConfirmDialogSubmit(forwardRules) }

        })

    }

    // Click su conferma del confirm dialog
    addForwardRuleConfirmDialogSubmit = (forwardRules: Partial<IForwardRule>[]) => {
        if (this.props.currentAoo) {
            this.setState({ loadingForwardRulesList: true });
            let { forceForwardRulesTableRefresh } = this.state

            forwardRulesService.addMultiForwardRule(this.props.currentAoo.id, forwardRules)
                .then(result => {
                    this.setState({ forceForwardRulesTableRefresh: !forceForwardRulesTableRefresh });
                    toastRef.current?.show({ severity: 'info', summary: 'Nuova regola', detail: `Nuova regola creata correttamente`, life: 5000 });

                })
                .catch(error => {
                    this.setState({ loadingForwardRulesList: false });

                });

            this.setState({ confirmDialogIsOpen: false })

        }
    }
    // Click sul button della commandbar
    updateForwardRuleHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditForwardRule
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Modifica regola di inoltro'
                    loading={false}
                    targetFieldIsReadOnly={true}
                    selectedForwardRule={this.state.selectedForwardRule}
                    onSubmit={this.updateForwardRuleLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                />

            }
        );
    }

    // Click su salva del panel laterale
    updateForwardRuleLateralPanelSubmit = (forwardRules: Partial<IForwardRule>[]) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi modificare la regola di inoltro?',
            },
            confirmDialogSubmitFunction: () => { this.updateForwardRuleConfirmDialogSubmit(forwardRules) }

        })

    }

    // Click su conferma del confirm dialog
    updateForwardRuleConfirmDialogSubmit = (forwardRules: Partial<IForwardRule>[]) => {
        if (this.props.currentAoo) {
            this.setState({ loadingForwardRulesList: true });
            let { forceForwardRulesTableRefresh } = this.state

            forwardRulesService.updateForwardRule(this.props.currentAoo.id, forwardRules[0])
                .then(result => {
                    this.setState({ forceForwardRulesTableRefresh: !forceForwardRulesTableRefresh });
                    toastRef.current?.show({ severity: 'info', summary: 'Modifica regola', detail: `Regola aggiornata correttamente`, life: 5000 });

                })
                .catch(error => {
                    this.setState({ loadingForwardRulesList: false });

                });

            this.setState({ confirmDialogIsOpen: false })

        }
    }

    // Click sul button della commandbar
    deleteForwardRuleHandler = () => {
        let { selectedForwardRule } = this.state;
        if (selectedForwardRule) {
            this.setState(
                {
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: `Vuoi rimuovere la regola selezionata?`,
                    },
                    confirmDialogIsOpen: true,
                    confirmDialogSubmitFunction: () => { this.deleteForwardRuleConfirmDialogSubmit(selectedForwardRule) }
                }
            );
        }
    }

    // Click su conferma del confirm dialog
    deleteForwardRuleConfirmDialogSubmit = (forwardRule: Partial<IForwardRule> | undefined) => {
        if (this.props.currentAoo && forwardRule) {
            let { forceForwardRulesTableRefresh } = this.state

            forwardRulesService.deleteForwardRule(this.props.currentAoo.id, forwardRule.id!)
                .then(result => {
                    this.setState({ forceForwardRulesTableRefresh: !forceForwardRulesTableRefresh });
                    toastRef.current?.show({ severity: 'info', summary: 'Eliminazione regola', detail: `Regola eliminata correttamente`, life: 5000 });

                })
                .catch(error => {
                    toastRef.current?.show({ severity: 'error', summary: 'Eliminazione regola', detail: `Regola non eliminata`, life: 5000 });

                    this.setState({ loadingForwardRulesList: false });

                });

            this.setState({ confirmDialogIsOpen: false });
            this.forwardRuleSelection.setAllSelected(false);
        }
    }

    //Click sul button della commandbar - 'Elimina voce'
    deleteFilingPlanNodeHandler = () => {        
            this.setState({
                lateralPanelIsOpen: false,
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi rimuovere la voce di titolario? ATTENZIONE: Saranno eliminate anche tutte le sottovoci`,
                },
                confirmDialogSubmitFunction: () => { this.deleteFilingPlanNodeConfirmDialogSubmit() }
            });      
    }

    // Click su conferma del confirm dialog - 'Elimina voce'
    deleteFilingPlanNodeConfirmDialogSubmit = () => {
        if (this.props.currentAoo && this.state.selectedFilingPlanNode) {
            let titolario: ITitolario = { ...this.state.selectedFilingPlanNode };
            let { forceFilingPlanTreeRefresh } = this.state

            if (titolario.id) {
                filingPlanService.deleteFilingPlanNode(this.props.currentAoo.id, titolario.id)
                    .then(result => { 
                        this.setState({ forceFilingPlanTreeRefresh: !forceFilingPlanTreeRefresh });
                        toastRef.current?.show({
                            severity: 'info',
                            summary: titolario.title,
                            detail: 'Voce di titolario eliminata correttamente',
                            life: 5000
                        })

                    })
                    .catch(error => {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: titolario.title,
                            detail: 'Voce di titolario non eliminata',
                            life: 5000
                        });
                    });
            }
            this.setState({ confirmDialogIsOpen: false, selectedFilingPlanNode: undefined });
        }
    }

    // Click sul button della commandbar - 'Modifica voce'
    editFilingPlanNodeHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,                
                lateralPanelBodyContent: () => <AddEditFilingPlanNode
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Modifica voce di titolario'
                    loading={false}
                    selectedFilingPlanNode={this.state.selectedFilingPlanNode}
                    onSubmit={this.editFilingPlanNodeLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={true}
                />
            }
        );
    }

    // Click su salva del panel laterale - 'Modifica voce'
    editFilingPlanNodeLateralPanelSubmit = (filingPlanNode: Partial<ITitolario>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: `Vuoi modificare la voce di titolario?`,
                
            },
            confirmDialogSubmitFunction: () => { this.editFilingPlanNodeConfirmDialogSubmit(filingPlanNode) }
        })
    }

    // Click su conferma del confirm dialog - 'Modifica voce'
    editFilingPlanNodeConfirmDialogSubmit = (filingPlanNode: Partial<ITitolario>) => {
        if (this.props.currentAoo && this.state.selectedFilingPlanNode) {
            let currentAoo = { ...this.props.currentAoo };
            let { forceFilingPlanTreeRefresh, selectedFilingPlanNode } = this.state;

            let title = filingPlanNode.title;

            let newTitolario = { ...selectedFilingPlanNode,labelTitleKey: title};
            let updatedLabelTitle = newTitolario.labelTitleKey;

            if (newTitolario.id && updatedLabelTitle) {

                filingPlanService.updateFilingPlanNode(currentAoo.id, newTitolario.id, newTitolario)
                    .then(result => {
                        this.setState({ forceFilingPlanTreeRefresh: !forceFilingPlanTreeRefresh });

                        toastRef.current?.show({
                            severity: 'info',
                            summary: filingPlanNode.title,
                            detail: `Voce di titolario aggiornata correttamente`,
                            life: 5000
                        })
                    })
                    .catch(error => {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: filingPlanNode.title,
                            detail: 'Voce di titolario non aggiornata',
                            life: 5000
                        });
                    });
            }
            this.setState({ confirmDialogIsOpen: false, selectedFilingPlanNode: undefined })
        }
    }

    dismissLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ lateralPanelIsOpen: false })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }


    onSelectFilingPlanHandler = (selected) => {
        let ordinamentoTitolarioConfiguration = this.props.arxeiaConfigurations?.find(el => el.key === "OrdinamentoTitolario")
        let itemKey;
        if (selected && ordinamentoTitolarioConfiguration && ordinamentoTitolarioConfiguration.value === "Indice") {
            itemKey = selected.labelIndexKey;

        }
        else if (selected && ordinamentoTitolarioConfiguration && ordinamentoTitolarioConfiguration.value === "Titolo") {
            itemKey = selected.labelTitleKey;
        }


        this.setState({
            selectedFilingPlanNode: selected,
            selectedFilingPlanNodeKey: itemKey
        })
    }

    onSelectForwardRuleHandler = (selected) => {
        this.setState({
            selectedForwardRule: selected
        })
    }

    render() {

        return (
            <React.Fragment>

                {this.state.lateralPanelBodyContent()}

                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>

                </Dialog>

                <div className="filig-plan-component flex flex-column p-nogutter" >

                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}

                        />
                    }
                    {
                        this.props.isMobile
                            // if true
                            ?
                            <div className="filig-plan-content flex flex-row">
                                <Pivot aria-label="Gestione titolario" styles={pivotBarStyles} className="flex flex-column filig-plan-pivot-component" >
                                    <PivotItem headerText="Titolario" className="filig-plan-pivot-item flex flex-column" >
                                        <div className={"filig-plan-tree col-12 lg:col-7 flex flex-column position-relative " + classNames.overFlowHidden}>
                                            <FilingPlanTree
                                                extraCssClass={`flex flex-column position-relative`}
                                                loadingFilingPlan={this.state.loadingFilingPlan}
                                                forceTreeRefresh={this.state.forceFilingPlanTreeRefresh}
                                                onSelectFilingPlanHandler={(selected) => this.onSelectFilingPlanHandler(selected)}
                                                editFilingPlanNodeHandler={this.editFilingPlanNodeHandler}
                                                deleteFilingPlanNodeHandler={this.deleteFilingPlanNodeHandler}
                                                addForwardRuleHandler={this.addForwardRuleHandler}
                                            />

                                        </div>
                                    </PivotItem>
                                    {
                                        this.state.selectedFilingPlanNode &&
                                        <PivotItem headerText="Regole di inoltro" className="flex flex-column" >

                                            <div className={"forward-rules-table col-12 lg:col-5 flex flex-column position-relative " + classNames.overFlowHidden}>
                                                <Label >{`Regole di inoltro per la voce di titolario "${this.state.selectedFilingPlanNodeKey}"`}:</Label>
                                                <ForwardRulesTable
                                                    loadingForwardRulesTable={this.state.loadingForwardRulesList}
                                                    forceTableRefresh={this.state.forceForwardRulesTableRefresh}
                                                    forwardRuleSelection={this.forwardRuleSelection}
                                                    forwardRulesFilter={{ fieldInternalName: 'Titolario', fieldInternalValue: this.state.selectedFilingPlanNodeKey }}
                                                    onSelectForwardRuleHandler={(selected) => this.onSelectForwardRuleHandler(selected)}
                                                />

                                            </div>

                                        </PivotItem>
                                    }
                                </Pivot>
                            </div>

                            //else non mobile
                            : <div className="filig-plan-content flex flex-row p-nogutter">
                                <div className={"filig-plan-tree col-12 lg:col-7 flex flex-column position-relative " + classNames.overFlowHidden}>

                                    <FilingPlanTree
                                        extraCssClass={`flex flex-column position-relative`}
                                        loadingFilingPlan={this.state.loadingFilingPlan}
                                        forceTreeRefresh={this.state.forceFilingPlanTreeRefresh}
                                        onSelectFilingPlanHandler={(selected) => this.onSelectFilingPlanHandler(selected)}
                                        editFilingPlanNodeHandler={this.editFilingPlanNodeHandler}
                                        deleteFilingPlanNodeHandler={this.deleteFilingPlanNodeHandler}
                                        addForwardRuleHandler={this.addForwardRuleHandler}
                                    />
                                </div>
                                {this.state.selectedFilingPlanNode &&
                                    <div className={"forward-rules-table col-12 lg:col-5 flex flex-column position-relative " + classNames.overFlowHidden}>
                                        <Label >{`Regole di inoltro per la voce di titolario "${this.state.selectedFilingPlanNodeKey}"`}:</Label>
                                        <ForwardRulesTable
                                            loadingForwardRulesTable={this.state.loadingForwardRulesList}
                                            forceTableRefresh={this.state.forceForwardRulesTableRefresh}
                                            forwardRuleSelection={this.forwardRuleSelection}
                                            forwardRulesFilter={{ fieldInternalName: 'Titolario', fieldInternalValue: this.state.selectedFilingPlanNodeKey }}
                                            onSelectForwardRuleHandler={(selected) => this.onSelectForwardRuleHandler(selected)}
                                            updateForwardRuleHandler={this.updateForwardRuleHandler}
                                            deleteForwardRuleHandler={this.deleteForwardRuleHandler}
                                        />

                                    </div>
                                }
                            </div>


                    }
                </div>
            </React.Fragment >

        )
    }
}

export default connector(withRouter(checkRoles(FilingPlan, RoleContext.Aoo)));
